var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M36,1C16.7,1,1,16.7,1,36s15.7,35,35,35s35-15.7,35-35S55.3,1,36,1z M41.8,12.3l7.5,1.6l-1.1,9.7l-6.6,1.1 L41.8,12.3z M38.9,12.1v13.4L36.3,26v6h-2.9l-1.2-17.6L38.9,12.1z M29.6,15.8l1.6,14.5L26,32.5l-2-13.9L29.6,15.8z M17.2,25l4.9-3.5 L24,33.7l-3.4,1.2L17.2,25z M48.2,59.9H32.3l-1.1-10.5L24,45.8l-1.9-8.9l9.1-3.5l4.7,0.9l0.2,5l15.3,0.7l-6,6.3L48.2,59.9z  M52.1,37.7l-14.4-0.9v-9.3l15.2-2.2L52.1,37.7z"
});

function SvgIconManifesto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManifesto);
export default __webpack_public_path__ + "static/media/icon_manifesto.86fcb63f.svg";
export { ForwardRef as ReactComponent };